import React from 'react';
import styled from 'styled-components';

interface FieldProps {
	children?: string;
}

const Label = styled.label`
	font-size: 22px;
	font-weight: 400;
	line-height: 22px;
	margin-bottom: 15px;
`;

export function Field({ children = '' }: Readonly<FieldProps>) {
	return <Label>{children}</Label>;
}
